import { render, staticRenderFns } from "./MRApproveButton.vue?vue&type=template&id=ff97631e"
import script from "./MRApproveButton.vue?vue&type=script&lang=ts"
export * from "./MRApproveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports